import { render, staticRenderFns } from "./ThemeButton.vue?vue&type=template&id=7015c4b4&scoped=true"
import script from "./ThemeButton.vue?vue&type=script&lang=js"
export * from "./ThemeButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7015c4b4",
  null
  
)

export default component.exports